export const cibOracle = ["32 32","<path d='M21.88 5.88h-11.755c-5.589 0-10.12 4.527-10.125 10.115-0.005 5.589 4.527 10.12 10.115 10.125h11.765c5.589 0 10.12-4.532 10.12-10.12s-4.531-10.12-10.12-10.12zM21.625 22.552h-11.245c-8.563-0.172-8.563-12.932 0-13.104h11.245c8.735 0 8.735 13.104 0 13.104z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-oracle.js
// module id = null
// module chunks = 